<template>
  <div class="promocode-component">
    <section class="d-flex align-center">
      <div class="promocode-name">
        <span class="font-weight-medium">{{ promocode.promoCode.code }}</span>
      </div>
      <div class="promocode-description">
        <span
          v-if="isFoxCoinPay"
          class="foxcoins-pay"
        >
          {{ foxCoinsCountLabel }}
        </span>
        <span
          v-else
          class="d-block description"
          :title="getFullPromocodeDescription"
        >
          {{ getPromocodeDescription }}
        </span>
      </div>
    </section>
    <div class="icon">
      <font-awesome-icon icon="gift" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'

  export default {
    name: 'Promocode',
    props: {
      promocode: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        order: state => state.orders.currentEditOrder,
      }),
      isFoxCoinPay () {
        return this.promocode &&
          this.promocode.promoCode &&
          this.promocode.promoCode.action === PromoCodeAction.FoxCoinPay
      },
      foxCoinsCountLabel () {
        return this.foxCoinsCount ? '-' + this.foxCoinsCount : 0
      },
      foxCoinsCount () {
        return this.basket ? this.basket.foxCoinsPayAmount : 0
      },
      getFullPromocodeDescription () {
        return this.promocode && this.promocode.promoCode ? this.promocode.promoCode.description : ''
      },
      getPromocodeDescription () {
        if (this.promocode && this.promocode.promoCode) {
          let descr = this.promocode.promoCode.description
          if (descr && descr.length > 58) {
            descr = descr.slice(0, 58)
            descr += '...'
          }
          return descr
        }
        return ''
      },
    },
  }
</script>

<style lang="less" scoped>
  .promocode-component {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 14px;
    border-radius: 10px;
    background-color: @color-secondary;
    margin-bottom: 9px;

    .promocode-name {
      padding: 9px 17px;
      border: 1px dashed #707070;
      border-radius: 10px;
      font-size: 21px;
      line-height: 1;
      margin-right: 20px;
    }

    .promocode-description {
      margin-right: 10px;
      .label {
        display: block;
        font-size: 12px;
        color: #7B7B7B;
      }

      .foxcoins-pay {
        font-size: 20px;
        color: #fe9923;
        display: flex;
        align-items: center;
        line-height: 1.2;
        font-weight: bold;

        &:after {
          display: inline-block;
          height: 24px;
          width: 24px;
          content: '';
          background: url("/img/icons/setcoins-icon.svg") no-repeat center center;
          background-size: contain;
          margin-left: 2px;
          margin-top: -2px;
        }

      }

      .description {
        cursor: default;
        max-height: 72px;
        max-width: 250px;
        text-overflow: ellipsis;
        overflow-y: hidden;
        word-wrap: break-word;
      }
    }

    .icon {
      svg {
        width: 40px;
        height: 35px;
      }
    }
  }
</style>
